import { render, staticRenderFns } from "./OpenApi.vue?vue&type=template&id=800050c2&scoped=true&"
import script from "./OpenApi.vue?vue&type=script&lang=js&"
export * from "./OpenApi.vue?vue&type=script&lang=js&"
import style0 from "./OpenApi.vue?vue&type=style&index=0&id=800050c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800050c2",
  null
  
)

export default component.exports